/**
 * AuthLoadingSpinner Component
 * คอมโพเนนต์ตัวโหลดสำหรับสถานะ auth
 */

import { useTranslation } from 'react-i18next'

export function AuthLoadingSpinner() {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div className="relative h-12 w-12">
          <div className="border-muted absolute inset-0 rounded-full border-4" />
          <div className="border-t-primary absolute inset-0 animate-spin rounded-full border-4 border-transparent" />
        </div>
        <p className="text-muted-foreground text-sm">{t('common.loading')}</p>
      </div>
    </div>
  )
}
